
import {
  REQUEST_OV_ACCOUNT_SERIES,
  RECEIVE_OV_ACCOUNT_SERIES
} from "../actions/usage";

const accumulateAccountData = data => {

  const result = {}

  data.forEach( ({ account_id, 
    cores,
    instance_cost,
    license_cost,
    minutes,
    storage,
    storage_cost
     }) => {
    if (! result.hasOwnProperty(account_id)) {
      result[account_id] = {cores:0, instance_cost:0, license_cost:0, minutes:0, storage:0, storage_cost:0}
    }
    result[account_id] = {
      cores: result[account_id].cores+cores,
      instance_cost: result[account_id].instance_cost+instance_cost,
      license_cost: result[account_id].license_cost+license_cost,
      minutes: result[account_id].minutes+minutes,
      storage: result[account_id].storage+storage,
      storage_cost: result[account_id].storage_cost + storage_cost,
    }
  });

  return result
};

function accountSeries(state = { data: [], loading: false }, action) {
  switch (action.type) {
    case REQUEST_OV_ACCOUNT_SERIES:
      return {...state, loading: true };

    case RECEIVE_OV_ACCOUNT_SERIES:
      const accumulated = accumulateAccountData(action.data)
      return {
        ...state,
        data: accumulated,
        loading: false
      };

    default:
      return state;
  }
}

export default accountSeries;



// WEBPACK FOOTER //
// ./src/reducers/overviewAccountSeries.js